import React from "react";
import { Col, Row } from "react-bootstrap";
import { formatPhoneNumber } from "react-phone-number-input";

import TextBlock from "../components/textBlock";

type InstallationData = {
	contact_first_name: string;
	contact_last_name: string;
	contact_phone_number: string;
	contact_email: string;
	notes: string;
};

type InstallationInformationViewProps = { data: InstallationData };

const InstallationInformationView = ({
	data,
}: InstallationInformationViewProps) => {
	const {
		contact_first_name,
		contact_last_name,
		contact_phone_number,
		contact_email,
		notes,
	} = data || {};
	return (
		<>
			<Row>
				<Col xl={3}>
					<TextBlock
						label="First Name"
						value={contact_first_name}
						dataAutotest="firstName"
					/>
				</Col>
				<Col xl={3}>
					<TextBlock
						label="Last Name"
						value={contact_last_name}
						dataAutotest="firstName"
					/>
				</Col>
				<Col xl={3}>
					<TextBlock
						label="Contact Phone"
						value={formatPhoneNumber(contact_phone_number)}
						dataAutotest="contactPhone"
					/>
				</Col>
				<Col xl={3}>
					<TextBlock
						label="Contact Email"
						value={contact_email}
						dataAutotest="contactEmail"
					/>
				</Col>
			</Row>
			<TextBlock label="Setup / Install Notes" />
			<TextBlock value={notes} dataAutotest="installNotes" />
		</>
	);
};

export default InstallationInformationView;
